export default "__VITE_ASSET__e838c77c__"